import React, { type FC, Fragment, useEffect } from 'react';

import { useAIAnswerContext } from './ai-answer-context';
import { aiAnswerDialogMetric } from './ai-answer-dialog-metric';

// Product is automatically prepended to the key

/**
 * @deprecated use 'MarkAIAnswerDialogMetricEnd' from common instead
 */
export const MarkAIAnswerDialogMetricEnd: FC = () => {
	const { isReadingAids, commonAttributes } = useAIAnswerContext();
	const { source } = commonAttributes;
	useEffect(() => {
		aiAnswerDialogMetric.stop({
			customData: { isReadingAids: !!isReadingAids, source },
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return <Fragment />;
};
